import React, { Component } from 'react';
//----  CONTAINERS ----
// import List from './containers/List';
// import Public from './containers/Public';
// import BackUrls from './containers/BackUrls';
// import old from './containers/401';
import Home from './components/Home';
import Login from './containers/Login';
//----  Navigation ----
import { Route, Switch, withRouter } from "react-router";
import PrivateRoute from "./PrivateRouter"
import './App.css';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import { setupInactivityListener } from './utils/InactivityHandler'; //auto logout
import Snackbar from '@mui/material/Snackbar'; //auto logout
import MuiAlert from '@mui/material/Alert'; //auto logout
import { connect } from 'react-redux'; //auto logout
import IconButton from '@mui/material/IconButton'; //auto logout
import CloseIcon from '@mui/icons-material/Close'; //auto logout

import CreatePFDPreview from './components/CreatePFDPreview'; // visualizar PDF
/* //Colocar debajo del switch para visualizar PDF con la ruta http://localhost:3000/#/preview-pdf
<Route exact path="/preview-pdf" component={CreatePFDPreview} /> 
*/

//Alerta
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

class App extends Component {

  state = {
    sessionExpired: false,
  };
  
  componentDidMount() {
    this.cleanupInactivity = setupInactivityListener({
      onSessionExpired: () => this.setState({ sessionExpired: true }),
      logout: () => this.props.dispatch({ type: 'RESET_ALL_DATA' }),
    });

    // Redirige al login después de mostrar el mensaje
    this.snackbarTimer = setTimeout(() => {
      if (this.state.sessionExpired) {
        this.props.history.push('/login');
      }
    }, 3000);
  }

  componentWillUnmount() {
    if (this.cleanupInactivity) this.cleanupInactivity();
    if (this.snackbarTimer) clearTimeout(this.snackbarTimer);
  }

  
  
  render() {
    return ( 
      <>
        <Switch>
          <Route exact path="/login" component={ Login }/>
          <PrivateRoute exact path="/" component={ Home }/>
          {/* <Route exact path="/clientes" component={ Cliente }/> */}
          {/*<Route exact path="/old/" component={ old }/>
          <Route component={ NOT_FOUND }/> */}
          </Switch>
      
          <Snackbar
            open={this.state.sessionExpired}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            onClose={() => this.setState({ sessionExpired: false })}
            action={
              <IconButton
                size="small"
                aria-label="close"
                color="inherit"
                onClick={() => this.setState({ sessionExpired: false })}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            }
          >
          <Alert severity="warning"
            onClose={() => this.setState({ sessionExpired: false })}
          >
            Tu sesión ha sido cerrada por inactividad. Por favor, inicia sesión nuevamente.
          </Alert>
        </Snackbar>
      </>
    );
  }
};

export default connect()(withRouter(App));